import types from "@/data/types"

const notes = (type) => {
    switch (type) {
        case types.XLS_TO_QR:
        case types.XLS_TO_QR_SG:
            return "Each image takes about 10 seconds to generate."
        default:
            return ""
    }
}

export default notes